import styled from "styled-components";
import { Container } from "./style";

export const ContentCryptocurrency = styled.div.attrs((props) => ({
    className: props.className,
}))
`
  iframe {
    margin-top: 15px;
    height: 340px;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }    
   
`;